
export const monthDayFormatter = new Intl.DateTimeFormat('en-US', {
    month: "long", // "July"
    day: "numeric" // "5"
});

export const monthDateYearFormatter = new Intl.DateTimeFormat('en-US', {
  month: "long",   // "July"
  day: "numeric",  // "5"
  year: "numeric"  // "2025"
});
